import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchCountsDone = (_, { payload }) => {
  return payload
};

const clearCountsDone = () => {
    return initialState
}
const initialState = {};
export default createReducer(initialState, {
  [TYPES.FETCH_COUNTS_DONE]: fetchCountsDone,
  [TYPES.CLEAR_COUNTS_DONE]: clearCountsDone,
})